var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenPlayButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#74B816"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30C14.4771 30 10 25.5228 10 20C10 14.4771 14.4771 10 20 10C25.5228 10 30 14.4771 30 20C30 25.5228 25.5228 30 20 30ZM20 28C24.4183 28 28 24.4183 28 20C28 15.5817 24.4183 12 20 12C15.5817 12 12 15.5817 12 20C12 24.4183 15.5817 28 20 28ZM18.6219 16.4146L23.5008 19.6672C23.6846 19.7897 23.7343 20.0381 23.6117 20.2219C23.5824 20.2658 23.5447 20.3035 23.5008 20.3328L18.6219 23.5854C18.4381 23.708 18.1897 23.6583 18.0672 23.4745C18.0234 23.4088 18 23.3316 18 23.2526V16.7474C18 16.5265 18.1791 16.3474 18.4 16.3474C18.479 16.3474 18.5562 16.3708 18.6219 16.4146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPlayButton);
export default __webpack_public_path__ + "static/media/GreenPlayButton.a4138ab4391dc381565707423ae219b2.svg";
export { ForwardRef as ReactComponent };